reWrapDetails